export default {
  minFontSize: 12,
  maxFontSize: 45,
  beforeExpiredTime: 5,
  flashcardWidth: 350,
  flashcardHeight: 350
};